import { Component, Input } from '@angular/core';
import { DEFAULT_DATE_TIME_FORMAT } from 'src/app/core/ccomx-date-formats';
import {
  IMessageLogRecipientDetailRow,
  IMessageLogTableRow,
} from 'src/app/message/models/send-message.model';

@Component({
  selector: 'app-message-template',
  templateUrl: './message-template.component.html',
  styleUrls: ['./message-template.component.scss'],
  standalone: false,
})
export class MessageTemplateComponent {
  @Input() columnName: string;
  @Input() element: IMessageLogTableRow | IMessageLogRecipientDetailRow;

  readonly dateTimeFormat = DEFAULT_DATE_TIME_FORMAT;

  get messageRow(): IMessageLogTableRow | null {
    return this.element && 'subject' in this.element ? this.element : null;
  }

  get recipientDetailRow(): IMessageLogRecipientDetailRow | null {
    return this.element && !('subject' in this.element) ? this.element : null;
  }

  get defaultValue(): string {
    const value = this.element?.[this.columnName as keyof typeof this.element];
    return value === null || value === undefined ? '' : `${value}`;
  }
}
